<template>
  <div id="btn-whatsapp">
      <a href="https://api.whatsapp.com/send?phone=5551985888363&text=Ol%C3%A1%2C%20visitei%20o%20seu%20site.%20Gostaria%20de%20solicitar%20um%20or%C3%A7amento.">
        <img src="@/assets/whatsapp.png" alt="">
      </a>
  </div>
</template>

<script>
export default {

}
</script>

<style>
    #btn-whatsapp {
        position: fixed;
        width: 55px;
        border-radius: 50%;
        z-index: 999;
        bottom: 20px;
        right: 20px;
        display: flex;
    }

    #btn-whatsapp img {
        max-width: 100%;
        border-radius: 50%;
    }
</style>